import artist from './artist/index';

export default {
  artist
}



// WEBPACK FOOTER //
// ./src/locales/no/component/module/index.js